import gql from 'graphql-tag';

export const ARTICLES_WITH_INSIGHTS_QUERY = gql`
  query ArticlesWithInsightsQuery(
    $filter: ArticlesFilterInput!
    $insightsFilter: AdInsightsFilterInput!
    $aggregationPeriod: String!
    $attributionWindow: AttributionWindowEnum
  ) {
    articles(filter: $filter) {
      campaignId
      id
      title
      url
      runStatus
      deprecated
      starred
      facebookPageId
      facebookPage {
        id
        facebookPageId
        facebookPageDisplayName
      }
      createdAt
      expirationTime
      publishTime
      goalCpcDollars
      articleGroup {
        id
      }
      budgetCapDollars
      facebookActiveAdSetsCount(filter: $filter)
      facebookActiveAdsCount
      campaign {
        name
        savedAudienceId
        useSavedAudience
        publisher {
          name
          publisherFacebookAccounts {
            priority
            facebookAccount {
              accountId
              businessId
            }
          }
          facebookAccounts {
            accountId
            timezone
          }
        }
      }
      audiencesWithSpend {
        id
        audienceSize
        audienceParsedDescription
        spent
      }
      keyweeFacebookCampaigns {
        facebookCampaignId
        adsManagerUrl
        facebookState
      }
      facebookSpentToday {
        spentToday
        discountSpentToday
      }
      storyAudienceMetrics {
        pending
        successful
        failed
        expired
      }
      # GOOGLE_RELATED_FIELDS
      googleCampaigns {
        id
        resourceName
        status
        primaryStatusReasons
        googleCampaignBudget {
          dailyBudget
        }
      }
      googleTodayCost
      googleAdsCount
      googleActiveAdsCount
      googleStatus
      insights(filter: $insightsFilter, aggregationPeriod: $aggregationPeriod, attributionWindow: $attributionWindow) {
        googleInsights {
          clicks
          impressions
          cost
          cpc
          cpm
          ctr
        }
        facebookInsights {
          spendBeforeDiscount
          spendAfterDiscount
          clicks
          impressions
          ctr
          cpm
          cpc
          maxCpa
          cpcRatio
          revenue
          revenueRoi
          profit
          pixelPageViews
          pixelSessions
          pixelAveragePageViewsPerSession
          pixelCostPerPageView
          conversions {
            id
            totalActions
            totalValue
            costPerAction
            roas
            aov
          }
        }
      }
    }
  }
`;
